export default "__VITE_ASSET__B1lquTD7__"